var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"dash"},[_c('tool-bar',{attrs:{"pageTitle":"BOOK.SIGHT"}}),_c('div',{class:_vm.handleBlur})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }